<dvlib-dialog [open]="dialogOpen" (dialogClose)="cancelEdit.emit()">
    <ng-template>
        <dv-termin-form [termin]="termin"
                        [terminTypes]="terminTypes"
                        (save)="save.emit($event)"
                        (cancelEdit)="cancelEdit.emit()">
        </dv-termin-form>
    </ng-template>
</dvlib-dialog>
